export var message_list = `
{{#messages}}
{{> messages/_message _current_user = ../_current_user}}
{{~/messages}}
`;
